<h1 class="text-4xl font-extrabold text-default">
  {{ 'Remove departments and/or teams from your organization' | translate }}
</h1>
<div class="text-xl font-medium text-default">
  {{
    "Select which items you'd like to remove, so that you can fit within your [planName] plan, then we will help you transfer the employees."
      | translate: { planName: planName() }
  }}
</div>
@if (quotas()[quotaType.DEPARTMENTS] || quotas()[quotaType.TEAMS]) {
  <div class="sticky top-0 z-sticky bg-surface py-md">
    <div sbCard>
      <div class="flex flex-col p-md" [class.gap-sm]="quotas()[quotaType.DEPARTMENTS] && quotas()[quotaType.TEAMS]">
        @if (quotas()[quotaType.DEPARTMENTS]) {
          <app-quota-card-rule [quotaType]="quotaType.DEPARTMENTS" [subscriptionPlanQuotas]="quotas()" />
        }
        @if (quotas()[quotaType.TEAMS]) {
          <app-quota-card-rule [quotaType]="quotaType.TEAMS" [subscriptionPlanQuotas]="quotas()" />
        }
      </div>
    </div>
  </div>
}

<div class="mb-32">
  <locations-table></locations-table>
</div>
<div
  class="fixed bottom-0 left-0 flex h-full max-h-32 w-full flex-col items-center justify-center gap-md border-0 border-t border-solid border-subtle bg-surface shadow-2xl"
>
  <button sb-button [disabled]="isOverQuota()" [color]="'primary'" class="w-full max-w-2xl" (click)="continue()">
    {{ 'Continue' | translate }}
  </button>
  <p class="mb-0 font-semibold text-default">
    {{ 'Changed your mind?' | translate }}
    <a
      [routerLink]="[
        '',
        { outlets: { modal: ['billing', 'plan-wizard', { originator: 'schedule-downgrade-quota-flow' }] } },
      ]"
      [queryParams]="{ upgrade: true }"
    >
      <span class="text-brand">
        {{ 'Upgrade your plan' | translate }}
      </span>
    </a>
  </p>
</div>
